import React, { useContext } from 'react'
import { Star, History } from 'lucide-react'
import { CantiqueContextAPI } from '../Context/CantiqueContext'

const SidebardCollections = () => {
  const { listMode, setListMode, favoriteCount, recentCount } = useContext(CantiqueContextAPI)

  const tabs = [
    { id: 'all', label: 'Tous' },
    { id: 'favorites', label: 'Favoris', icon: Star, count: favoriteCount },
    { id: 'recents', label: 'Récents', icon: History, count: recentCount },
  ]

  return (
    <div className="sidebardCollections" role="tablist" aria-label="Afficher">
      {tabs.map(({ id, label, icon: Icon, count }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={listMode === id}
          className={`sidebardCollections__tab ${listMode === id ? 'active' : ''}`}
          onClick={() => setListMode(id)}
        >
          {Icon && <Icon size={13} />}
          <span>{label}</span>
          {count > 0 && <span className="sidebardCollections__count">{count}</span>}
        </button>
      ))}
    </div>
  )
}

export default SidebardCollections
